export default __webpack_public_path__ + "static/media/m_engineering_card06_1.29191e66.png";